import { MapPinIcon, EnvelopeIcon, ChevronRightIcon } from "@heroicons/react/24/solid"
import Link from "next/link"
const navigation = {

  products: [
    { name: 'Catalogue', href: '/catalog' },
    { name: 'Custom Corporate Uniforms', href: '/our-products' }
  ],

  solutions: [
    { name: 'Order Management', href: '/order-management-platform' },
    { name: 'RFID System', href: '/linen-management-system' },
    { name: 'Inventory Management', href: '/inventory-management-solution' },
    { name: 'Laundry Services', href: '/laundry-services-singapore' },
    { name: 'Cleanroom Laundry', href: '/cleanroom-laundry-and-managed-rfid-garment-solutions' },
    { name: 'Custom Uniform Rental', href: '/custom-uniform-rental' },
    { name: 'Enterprise Program', href: '/enterprise-programme' },
  ],

  industries: [
    { name: 'Food and Beverage', href: '/food-and-beverage' },
    { name: 'Medical and Healthcare', href: '/medical-and-healthcare' },
    { name: 'Custom Tees and Polo', href: '/customtees-and-polo' },
    { name: 'Construction, Manufacturing and Engineering', href: '/construction-manufacturing-engineering' },
    { name: 'Cleanroom', href: '/cleanroom' },
  ],

  company: [
    { name: 'About Us', href: '/about-us' },
    // { name: 'Partner Us', href: '/become-a-partner' },
    { name: 'Sustainability', href: '/sustainability' },
    { name: 'Community', href: '/community' }
  ],

  resources: [
    { name: 'Blog', href: '/blogs' },
    { name: 'FAQ', href: '/help' },
    { name: 'Contact Us', href: '/contact-us' },
    { name: 'Legal', href: '/terms/customer' },
    { name: 'Wiki', href: '/wiki' }
  ],

  social: [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/MERCHFOUNDRY',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/merchfoundry/',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: 'Linkedin',
      href: 'https://www.linkedin.com/company/merchfoundry/',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M11.1053 20.9998H7.12085V7.14963H10.9929C11.0542 7.59393 11.1155 8.05357 11.2228 8.82983C12.7042 7.09856 14.5125 6.81257 16.4638 6.94535C18.8953 7.11388 20.8722 8.91154 20.9489 11.3272C21.051 14.4935 20.9744 17.6649 20.9744 20.9487H16.8878C16.8878 18.4974 16.9134 16.0716 16.8878 13.6457C16.8878 12.3179 16.3361 11.2557 14.9978 10.8114C14.4203 10.5833 13.7812 10.5647 13.1914 10.7587C12.6016 10.9528 12.0985 11.3472 11.7693 11.8736C11.3599 12.5837 11.1416 13.3879 11.1359 14.2075C11.0491 16.4546 11.1053 18.6863 11.1053 20.9998Z"/>
          <path d="M4.42377 21H0.541504V7.17529H4.42377V21Z"/>
          <path d="M2.62568 -0.000175017C2.95499 0.0174188 3.27728 0.10181 3.57295 0.24785C3.86862 0.39389 4.13149 0.598533 4.34556 0.849335C4.55963 1.10014 4.72043 1.39184 4.81818 1.70673C4.91593 2.02162 4.94859 2.3531 4.91418 2.681C4.89511 3.00926 4.80991 3.33029 4.66369 3.62482C4.51747 3.91935 4.31324 4.18131 4.06326 4.39498C3.81328 4.60866 3.52271 4.76964 3.20896 4.86826C2.89521 4.96689 2.56477 5.00114 2.23746 4.96895C1.59902 4.91418 1.00752 4.61121 0.590109 4.12514C0.172696 3.63907 -0.037336 3.00871 0.00514246 2.36948C0.016752 2.04027 0.0943381 1.71672 0.233305 1.41803C0.372272 1.11934 0.569802 0.851585 0.814172 0.63061C1.05854 0.409636 1.34479 0.239934 1.65595 0.131583C1.96712 0.023233 2.29687 -0.0215663 2.62568 -0.000175017Z"/>
        </svg>
      ),
    },
    {
      name: 'Blog',
      href: 'https://mf.asia/blogs',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M12.8006 24H11.2084C11.1418 23.9812 11.0739 23.9669 11.0054 23.9571C9.71119 23.874 8.44279 23.5568 7.26175 23.021C2.97684 21.02 0.53444 17.6656 0.0563342 12.9373C-0.119954 11.1345 0.144744 9.31594 0.827614 7.63831C1.80052 5.12145 3.596 3.00781 5.92208 1.64109C8.24817 0.274374 10.9681 -0.265046 13.6395 0.110533C16.4238 0.465022 18.9865 1.81322 20.8562 3.90713C22.4042 5.57681 23.429 7.6638 23.8037 9.90995C23.8782 10.3386 23.93 10.7717 23.9909 11.2025V12.7974C23.9548 13.0817 23.9255 13.3659 23.8827 13.6502C23.6202 15.6063 22.8686 17.4646 21.6974 19.0529C20.7711 20.3429 19.5951 21.4333 18.2391 22.2596C16.8831 23.0858 15.3749 23.6308 13.8041 23.8624C13.4794 23.9165 13.1388 23.9526 12.8006 24ZM11.9932 22.5089C13.3741 22.5107 14.7418 22.24 16.0181 21.7124C17.2943 21.1849 18.454 20.4107 19.4307 19.4343C20.4075 18.4579 21.1822 17.2984 21.7104 16.0221C22.2387 14.7459 22.5101 13.3779 22.5093 11.9966C22.5122 9.21254 21.4101 6.54118 19.445 4.56958C17.4798 2.59799 14.8125 1.48747 12.0293 1.48209C10.6491 1.47854 9.28178 1.74711 8.00546 2.27248C6.72914 2.79785 5.56885 3.56971 4.59093 4.54392C3.61302 5.51813 2.83666 6.67558 2.30624 7.95011C1.77581 9.22464 1.50173 10.5912 1.49966 11.9718C1.49581 13.3532 1.7643 14.7218 2.28979 15.9993C2.81527 17.2769 3.58743 18.4382 4.56208 19.4169C5.53673 20.3956 6.69475 21.1724 7.96986 21.703C9.24497 22.2335 10.6122 22.5074 11.9932 22.5089Z"/>
          <path d="M9.6433 17.7827C8.49539 14.3651 7.35876 10.9813 6.21085 7.56823L6.92575 7.50281C7.05805 7.49397 7.18978 7.47815 7.32041 7.45544C7.41471 7.44302 7.50069 7.39496 7.56066 7.32112C7.62064 7.24729 7.65007 7.15327 7.64292 7.0584C7.64153 7.009 7.63013 6.9604 7.60943 6.91553C7.58873 6.87066 7.55915 6.83046 7.52247 6.79735C7.48578 6.76424 7.44277 6.73892 7.39602 6.72292C7.34928 6.70691 7.29977 6.70055 7.2505 6.70423C6.89192 6.70423 6.53561 6.75613 6.17703 6.7674C5.55234 6.78771 4.92764 6.79673 4.30295 6.80801C4.24925 6.80678 4.19572 6.8015 4.14282 6.79222C7.14 2.05493 14.0297 1.03528 18.3123 4.98753C18.055 5.03984 17.8029 5.11535 17.5591 5.21312C17.2037 5.40331 16.9289 5.71559 16.7855 6.09243C16.6421 6.46926 16.6397 6.88524 16.7788 7.26369C16.9507 7.72991 17.1683 8.17799 17.4283 8.60141C17.7992 9.18864 18.084 9.82601 18.274 10.4941C18.4547 11.2982 18.4181 12.136 18.168 12.9214C17.717 14.4847 17.2389 16.0412 16.772 17.6C16.7536 17.6364 16.7333 17.6718 16.7111 17.706C15.5722 14.3222 14.4446 10.9588 13.3058 7.57049L14.0365 7.50507C14.1537 7.49379 14.262 7.48701 14.386 7.46446C14.437 7.46188 14.4868 7.44865 14.5324 7.42561C14.5779 7.40258 14.6182 7.37026 14.6505 7.33073C14.6827 7.2912 14.7064 7.24534 14.7199 7.1961C14.7334 7.14687 14.7364 7.09535 14.7288 7.04487C14.726 6.99363 14.7124 6.94356 14.689 6.89792C14.6656 6.85227 14.6328 6.81207 14.5928 6.77993C14.5528 6.7478 14.5065 6.72445 14.4569 6.71141C14.4072 6.69837 14.3554 6.69592 14.3048 6.70423C13.9688 6.71551 13.6283 6.74259 13.299 6.7674C12.0832 6.84149 10.8636 6.82641 9.65005 6.72228C9.52572 6.70915 9.40069 6.70387 9.27569 6.70649C9.18047 6.70986 9.09005 6.7492 9.02267 6.8166C8.95529 6.884 8.91596 6.97443 8.91259 7.06968C8.90731 7.11652 8.91155 7.16395 8.92505 7.2091C8.93855 7.25426 8.96104 7.29621 8.99116 7.33246C9.02129 7.3687 9.05842 7.39847 9.10035 7.42C9.14227 7.44152 9.1881 7.45434 9.2351 7.45769C9.51249 7.4983 9.79213 7.52988 10.0718 7.54568C10.125 7.54002 10.1785 7.55348 10.2227 7.58365C10.2669 7.61382 10.2989 7.65872 10.3131 7.71035C10.7641 8.97137 11.2265 10.2301 11.682 11.4889C11.7055 11.5623 11.7055 11.6411 11.682 11.7145C11.025 13.7041 10.365 15.6915 9.70192 17.6767C9.68531 17.7136 9.66571 17.7491 9.6433 17.7827Z"/>
          <path d="M9.32983 21.0718C10.2748 18.3287 11.2129 15.6014 12.1691 12.8154C13.1682 15.5473 14.1447 18.2295 15.1325 20.9365C13.2601 21.5879 11.2306 21.6352 9.32983 21.0718Z"/>
          <path d="M7.87979 20.4969C3.02431 18.144 1.38702 12.4074 3.38288 8.1709C4.88035 12.2788 6.37105 16.3642 7.87979 20.4969Z"/>
          <path d="M20.3082 7.53027C22.5634 11.4194 21.5689 17.3365 16.7743 20.163C16.8036 20.057 16.8217 19.9803 16.8465 19.9081C17.8726 16.9507 18.9055 13.9955 19.9181 11.0359C20.3136 9.91236 20.447 8.71328 20.3082 7.53027Z"/>
        </svg>

      ),
    },
    {
      name: 'Pinterest',
      href: 'https://www.pinterest.com/merchfoundry/',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M12 0C5.37366 0 0 5.37365 0 12C0 17.0157 3.07896 21.3136 7.44943 23.1067C6.94404 19.1918 8.37169 16.2153 9.04278 13.061C7.87961 11.1923 9.1865 7.42044 11.644 8.35137C14.6697 9.49483 9.02198 15.3063 12.8146 16.0319C16.7713 16.7918 18.3868 9.48773 15.9362 7.1124C12.3834 3.68972 5.61319 7.03709 6.44841 11.9384C6.55103 12.5477 7.55047 13.5057 7.55047 13.5057C7.55047 13.5057 7.50256 14.0873 7.24243 15.1623C4.9698 14.6831 4.01827 12.9786 4.10777 10.7059C4.24469 6.98199 7.61257 4.38082 10.9942 4.01797C15.2658 3.5593 19.2772 5.51028 19.8385 9.34371C20.4614 13.67 17.9081 18.3523 13.3354 18.0168C12.0963 17.9281 11.5761 17.3391 10.604 16.7778C10.0883 19.3543 9.46438 21.8285 7.68019 23.1987C9.05834 23.7301 10.5229 24.0018 12 24.0002C18.6263 24.0002 24 18.6265 24 12.0002C24 5.37385 18.6263 0 12 0Z"/>
        </svg>
      ),
    },
  ],
}

export default function Example() {
  return (
    <footer className="bg-gray-100" aria-labelledby="footer-heading">
      {/* <h2 id="footer-heading" className="sr-only">
        Footer
      </h2> */}
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-20 lg:px-8 lg:pt-20">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-8">
            <div className="flex space-x-6">
              {navigation.social.map((item) => (
                <Link key={item.name} href={item.href} className="text-gray-900 hover:text-blue-600" rel="noreferrer" target="_blank">
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </Link>
              ))}
            </div>
            {/* <img
              className="h-7"
              src="https://tailwindui.com/img/logos/mark.svg?color=blue&shade=500"
              alt="Company name"
            /> */}
            <p className="text-sm leading-6 text-gray-900">
              MF is Asia’s most advanced corporate uniform and workwear platform, which includes Singapore, Malaysia, Indonesia, Vietnam and China. With a price guarantee and absolute reliability, MF offers businesses direct to factory pricing from our vetted partners for all your wearables. From medical scrubs, lab coats, disposable scrubs, doctors’ coat to chef uniforms, chef caps, custom t-shirts, engineering and technician overalls and safety gear. We also offer accompanying laundry services in Singapore & Malaysia. Upgrade your corporate uniform supply chain today, save yourself precious time and focus on what you do best.
            </p>
            
          </div>
          <div className="mt-16 grid grid-cols-2 gap-x-8 gap-y-12 md:grid-cols-4 xl:col-span-2 xl:mt-0">
            {/* Row 1 — Products | Solutions | Industries | Resources */}
            <div>
              <h3 className="text-md font-semibold leading-6 text-gray-900 uppercase">Products</h3>
              <ul role="list" className="mt-6 space-y-3">
                {navigation.products.map((item) => (
                  <li key={item.name}>
                    <Link href={item.href} className="text-sm font-medium leading-6 text-gray-900 hover:text-blue-600">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-md font-semibold leading-6 text-gray-900 uppercase">Solutions</h3>
              <ul role="list" className="mt-6 space-y-3">
                {navigation.solutions.map((item) => (
                  <li key={item.name}>
                    <Link href={item.href} className="text-sm font-medium leading-6 text-gray-900 hover:text-blue-600">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-md font-semibold leading-6 text-gray-900 uppercase">Industries</h3>
              <ul role="list" className="mt-6 space-y-3">
                {navigation.industries.map((item) => (
                  <li key={item.name}>
                    <Link href={item.href} className="text-sm font-medium leading-6 text-gray-900 hover:text-blue-600">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-md font-semibold leading-6 text-gray-900 uppercase">Resources</h3>
              <ul role="list" className="mt-6 space-y-3">
                {navigation.resources.map((item) => (
                  <li key={item.name}>
                    <Link href={item.href} className="text-sm font-medium leading-5 text-gray-900 hover:text-blue-600">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Row 2 — Company (1 col) | Contact (3 cols, items in 2 sub-cols) */}
            <div className="col-span-2 md:col-span-1">
              <h3 className="text-md font-semibold leading-6 text-gray-900 uppercase">Company</h3>
              <ul role="list" className="mt-6 space-y-3">
                {navigation.company.map((item) => (
                  <li key={item.name}>
                    <Link href={item.href} className="text-sm font-medium leading-6 text-gray-900 hover:text-blue-600">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-2 md:col-span-2">
              <div>
                <h3 className="text-md font-semibold leading-6 text-gray-900 uppercase">Contact</h3>
                <ul role="list" className="mt-6 space-y-3">
                  <li>
                    <p className="text-sm font-medium leading-6 text-gray-900">
                      <MapPinIcon className="text-gray-900 inline mb-1 h-5 w-5 mr-2"/>
                      63 Jalan Pemimpin, Pemimpin Industrial Building #06-03, Singapore 577219
                    </p>
                  </li>

                  <li>
                    <p className="text-sm font-medium leading-6 text-gray-900">
                      <EnvelopeIcon className="text-gray-900 inline mb-1 h-5 w-5 mr-2"/>
                      hello@mf.asia
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div className="bg-gray-900 py-8 mt-10">
        <p className="text-md tracking-wide text-center m-auto leading-5 text-white">MF ASIA | COPYRIGHT &copy; { new Date().getFullYear() }</p>
      </div>
    </footer>
  )
}
